import { z } from 'zod';
// Canonical error envelope returned by every backend route on a non-2xx
// response. Single shape across the entire API; consumed by frontend axios
// interceptors (ADR-010) for branch routing on `code`. Concrete codes
// (`MUST_CHANGE_PASSWORD`, `PROJECT_SUSPENDED`, `PROJECT_TERMINATED`,
// `PROJECT_NOT_FOUND`, …) are open strings layered on top of this envelope.
export const ErrorResponseSchema = z
    .object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
    request_id: z.string().optional(),
})
    .strict();
